import { Component, Inject, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
declare var $: any;

@Component({
  templateUrl: './cyber.html',
  styleUrls: ['./cyber.css'],
})
export class Cyber implements OnInit {

   URL  =  'https://inkafarma.pe/cyber-days';

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.redirigir();
  }

  ngOnInit() {
    
  }

  redirigir(): void {
    this.document.location.href = this.URL;
  }

}
